<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Origine Contatto' : 'Nuova Origine Contatto' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-contact-source-form [data]="data"></app-contact-source-form>
</div>
